import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CANCEL_ERROR } from 'apisauce';

import useCancellableRequest from '../Hooks/useCancellableRequest';
import { updateCheckoutDetails } from '../RTK/checkout';
import { checkout } from '../RTK/defaultValues';
import { setMealPlanCheckoutData } from '../RTK/mealPlan';
import { setUserAddressAsFirst } from '../RTK/user';
import { isGuestSelector } from '../RTK/user/selectors';
import userApi from '../Service/api/user';

import useMealPlan from './useMealPlan';

const useAddress = () => {
  const dispatch = useDispatch<any>();
  const { createRequest } = useCancellableRequest();
  const isGuest = useSelector(isGuestSelector);
  const { isMealPlan } = useMealPlan();
  const [isLoading, setLoading] = useState(false);

  const _setActiveAddress = async (address) => {
    setLoading(true); // set loading
    const { ok, problem } = isGuest
      ? { ok: true } // if guest, no network request just make it as ok
      : await createRequest(userApi.setAddressAsActive, address?.id);

    setLoading(false); // remove loading state
    if (!ok || problem === CANCEL_ERROR) return; // stop the code from going if failed api or request cancelled
    dispatch(setUserAddressAsFirst(address?.id));

    // dispatch to checkout data if has storeId (if has it, it means user is in store page)
    if (address?.storeId) {
      if (isMealPlan) {
        dispatch(
          setMealPlanCheckoutData({
            key: checkout.keys.DELIVERY_ADDRESS,
            data: { ...address },
          }),
        );
      } else {
        dispatch(
          updateCheckoutDetails({
            store_id: address?.storeId,
            keyToUpdate: checkout.keys.DELIVERY_ADDRESS,
            keyValue: { ...address },
          }),
        );
      }
    }
  };

  return {
    setActiveAddress: _setActiveAddress,
    isLoading,
  };
};

export default useAddress;
